import DataDisplayRowI from "../DataDisplayRowI";
import getNotificationRow from "../DataDisplayRow/NotificationRow";
import DataDisplayTable from "../DataDisplayTable";

class NotificationTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getNotificationRow()
    }
}

let notificationTable: NotificationTable | null = null;

export default function getNotificationTable(): NotificationTable {
    if (notificationTable === null)
        notificationTable = new NotificationTable()
    return notificationTable
}